import React from 'react'
import { useBlocker } from 'react-router-dom'
import { UnsavedChangesContext, UNSAVED_MESSAGE } from '../../context/UnsavedChangesContext'

export const UnsavedChangesProvider = ({ children }) => {
  const [dirty, setDirty] = React.useState(false)
  const confirmDiscard = React.useCallback(() => !dirty || window.confirm(UNSAVED_MESSAGE), [dirty])
  const blocker = useBlocker(({ currentLocation, nextLocation }) => dirty && (
    currentLocation.pathname !== nextLocation.pathname || currentLocation.search !== nextLocation.search
  ))
  React.useEffect(() => {
    if (blocker.state !== 'blocked') return
    if (window.confirm(UNSAVED_MESSAGE)) blocker.proceed()
    else blocker.reset()
  }, [blocker])
  React.useEffect(() => {
    if (!dirty) return undefined
    const warn = (event) => { event.preventDefault(); event.returnValue = '' }
    window.addEventListener('beforeunload', warn)
    return () => window.removeEventListener('beforeunload', warn)
  }, [dirty])
  const value = React.useMemo(() => ({ setDirty, confirmDiscard }), [confirmDiscard])
  return <UnsavedChangesContext.Provider value={value}>{children}</UnsavedChangesContext.Provider>
}
